// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__ySwWs","cardwithpadding":"Card_cardwithpadding__FapcP","fadeIn":"Card_fadeIn__Os4ku"};